module.exports = __webpack_public_path__ + "img/icon_payment_american_express.27fea6ec.svg";